import { render } from "./App.vue?vue&type=template&id=7b20e3f1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/css/main.scss?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=7b20e3f1&lang=scss"

import exportComponent from "/home/s-ol/dot/multi/multi-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__